/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import './sign-canvas.css';
import React, { useRef, useCallback, useEffect, useState, useMemo } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import useTheme from '../../hooks/useTheme';

function SignCanvas({ className, onChange, clear, setStrokeLength }) {
    const [screenVertical, setScreenVertical] = useState(true);
    const sigCanvas = useRef({});
    const sigPad = useRef({});

    const theme = useTheme();

    const penColor = useMemo(() => {
        // if(theme === 'cuotitas') return '#2f4f83'
        // if(theme === 'cuota-ya') return '#E10634'
        // if(theme === 'demo') return '#B61989'
        return 'blue'
    }, [theme])

    const measuredRef = useCallback (node => {
        try {
            if (node !== null) {
                sigCanvas.current = node.getCanvas();
                sigPad.current = node.getSignaturePad();
            }
        } catch (error) {
            console.error(error)
        }
    }, []);


    const getStrokeLength = (imageData) => {
        let length = 0;
        for (let i = 0; i < imageData.length; i += 4) {
            if (imageData[i + 3] > 0) {
                length++;
            }
        }
        return length;
    };

    function updatePointGroup() {

        try {
            const canvas = sigCanvas.current;
            const context = canvas.getContext('2d');
            const canvasWidth = canvas.width;
            const canvasHeight = canvas.height;

            /* Calculate stroke length */
            const length = getStrokeLength(context.getImageData(0, 0, canvasWidth, canvasHeight).data);
            setStrokeLength(length);


            const dataURL = sigCanvas.current.toDataURL();
            onChange(dataURL);
        } catch (error) {
            console.error(error)
        }
    };

    function blockScreenOrientation () {
        return window.screen.orientation.lock("portrait")
            .then(function () {
                return console.error('Locked');
            })
            .catch(function (error) {
                console.error(error);
                return enableSignPad(window.screen);
            })
    };

    async function enableSignPad (screen) {
        const isVertical = isVerticalDevice();

        if (isVertical)
            await sigPad.current.on();
        else
            await sigPad.current.off();

        setScreenVertical(isVertical);
    }

    function clearSignPad () {
        sigPad.current.clear();
    }

    function isVerticalDevice () {
        return ![90, -90].includes(window?.orientation);
    }

    useEffect(() => {
        try {
            clear && clearSignPad();
            blockScreenOrientation();
        } catch (error) {
            console.error(error)
        }
        return () => {
            console.log('fin sign canvas')
        }
    }, [clear, window?.orientation]);

    return (
        <div id='container-signature-canvas' className={className}>
            {!isVerticalDevice() && <div id='turn'>
                <h3 style={{ color: 'red' }}>Por favor, coloque el celular de forma vertical</h3>
            </div>}
            <div id='signatureSignPad' className={isVerticalDevice() ? 'divSigCanvasHor' : 'disableSigCanvasHor'}>
                <SignatureCanvas
                    penColor={penColor}
                    canvasProps={{  id: 'canvasSignPad', style:{width: '100%', height: '100%'} ,className: 'sigCanvasHor' }}
                    onEnd={updatePointGroup}
                    ref={measuredRef}
                    clearOnResize={false}
                    throttle={10}
                />
            </div>
        </div>
    );
}

export default SignCanvas;
